import React from "react";

const LoneWolfLogo = () => {
    return (
        <a href="https://lwolf.com">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                height="31"
                viewBox="0 0 173 31"
                width="173"
                style={{
                    width: '196px',
                    height: '50px',
                    display: 'block',
                    marginTop: '30px',
                }}
            >

                <g fill="#233d2d">
                    <path
                        d="m.550781 30.0543v-.2057l1.500669-2.0229v-23.62285l-1.500669-2.02286v-.20571h9.384969v.20571l-1.50067 2.02286v24.98285h6.08922l7.1773-5.9057h.5829l-2.5453 6.7686v.0057z" />
                    <path
                        d="m22.1172 20.3514c0-6.2771 4.3404-10.48855 10.3459-10.48855 6.0056 0 10.1324 4.21425 10.1324 10.11995 0 6.2772-4.3404 10.4886-10.3055 10.4886-5.9652 0-10.1815-4.2143-10.1815-10.12zm13.8436-.1657c0-6.7686-1.0447-9.5371-3.5842-9.5371-2.6724 0-3.6276 2.8085-3.6276 9.4971s1.0447 9.5371 3.6276 9.5371c2.5828 0 3.5842-2.8085 3.5842-9.4971z" />
                    <path
                        d="m64.4303 30.0543h-8.3807v-.2057l1.2121-1.8572v-11.1486c0-2.52-1.5843-3.3857-3.5439-3.3857-1.2525 0-2.1673.3715-2.7127.7v13.8343l1.2121 1.8572v.2057h-8.424v-.2057l1.2525-1.8572v-14.9086l-1.1688-2.6028v-.2057h7.1368v3.3028c1.3766-1.8571 3.7084-3.71425 6.7559-3.71425 3.4198 0 5.4198 2.31425 5.4198 5.74285v12.3886l1.2525 1.8571v.2057h-.0058z" />
                    <path
                        d="m75.1284 30.4657c-5.8411 0-9.6332-4.0914-9.6332-9.8657 0-6.1114 4.1326-10.73715 9.7601-10.73715 4.7127 0 7.9247 2.97425 8.3403 7.43425h-12.9288c.0404 5.16 2.2914 8.92 7.6765 8.92 2.2914 0 4.0489-.7 5.0878-1.5685l.3319.2885c-1.0447 2.7257-3.7517 5.5343-8.6375 5.5343l.0057-.0057zm-4.4645-14h6.7559c-.2078-3.9657-1.1688-5.7-3.2524-5.7-2.0837 0-3.3766 1.6514-3.5035 5.7z" />
                    <path
                        d="m130.215 2.17999-2.837 4.58286-6.257 23.28855h-5.881l-5.088-17.1771-4.505 17.1771h-5.9653l-7.5929-25.56284-1.668-2.31428v-.20572h8.9694v.20572l-.6234 2.14571 6.6722 22.71431 4.213-15.8972-1.959-6.64568-1.709-2.31428v-.20572h9.013v.20572l-.623 2.14571 6.588 22.58855 5.38-20.19141-1.085-4.54285v-.20572h4.963v.21143z" />
                    <path
                        d="m126.838 20.3514c0-6.2771 4.34-10.48855 10.346-10.48855s10.132 4.21425 10.132 10.11995c0 6.2772-4.34 10.4886-10.305 10.4886s-10.182-4.2143-10.182-10.12zm13.841-.1657c0-6.7686-1.045-9.5371-3.584-9.5371-2.673 0-3.628 2.8085-3.628 9.4971s1.045 9.5371 3.628 9.5371c2.582 0 3.584-2.8085 3.584-9.4971z" />
                    <path
                        d="m148.211 1.76856 7.425-1.239996v27.460036l1.253 1.8571v.2057h-8.424v-.2057l1.252-1.8571v-23.32861l-1.5-2.68571v-.20572z" />
                    <path
                        d="m171.192 10.2714v1.94h-5.129v15.7714l1.336 1.8572v.2057h-8.548v-.2057l1.253-1.8572v-15.7714h-2.505v-1.94h2.505c0-2.68569 2.167-5.03712 4.297-6.64569 2.251-1.69143 4.92-2.931431 8.049-2.931431v4.582861h-6.632v4.99426h5.379z" />
                </g>
            </svg>
        </a>
    );
};

export default LoneWolfLogo;
